import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, Search, ClipboardList, User } from "lucide-react";
import { useApp } from "@/store/AppContext";

const TABS = [["Home", "/", Home], ["Baskets", "/weekly-basket", LayoutGrid], ["Search", "/search", Search], ["Orders", "/orders", ClipboardList], ["Account", "/account", User]];

export function BottomNav() {
  const { cartCount } = useApp();
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur border-t border-[var(--line)]" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} aria-label="Bottom navigation" data-testid="bottom-nav">
      <div className="grid grid-cols-5 h-16">
        {TABS.map(([l, to, Icon]) => (
          <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `flex flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${isActive ? "text-[var(--brand-primary)]" : "text-[var(--muted)]"}`} data-testid={`tab-${l.toLowerCase()}`}>
            <span className="relative"><Icon size={22} />{l === "Orders" && cartCount > 0 && <span className="absolute -top-1 -right-2 w-2 h-2 rounded-full bg-[var(--warning)]" />}</span>{l}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
